module.exports = __webpack_public_path__ + "img/0Q3B3739_FoamcoreMatted.b5cfaf85.jpg";